function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { useState } from 'react';
import { HiddenField } from '@guryou/html-components';
import { KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from 'prop-types';
const TIME_FORMAT = 'HH:mm';
const TimePickers = _ref => {
  let {
    fieldName,
    value,
    label,
    onChange,
    ...rest
  } = _ref;
  const [defaultValue, setDefaultValue] = useState(moment(value, TIME_FORMAT));
  const onChangeHandler = date => {
    setDefaultValue(date);
    onChange && onChange(date);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenField, {
    name: fieldName,
    value: defaultValue ? defaultValue.format(TIME_FORMAT) : ''
  }), /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({}, rest, {
    style: {
      margin: '1rem 0',
      width: '40%',
      padding: '4px 0'
    },
    InputProps: {
      name: null
    },
    autoOk: true,
    label: label,
    ampm: false,
    value: defaultValue,
    minutesStep: 5,
    onChange: onChangeHandler
  })));
};
TimePickers.propTypes = {
  disablePast: PropTypes.bool,
  format: PropTypes.string,
  fieldName: PropTypes.string
};
TimePickers.defaultProps = {
  disablePast: true
};
export default TimePickers;